// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__gMsgh","main":"Dashboard_main__eh3nW"};